/* eslint-disable import/no-anonymous-default-export */
import { IZones } from "../../../../shared/interfaces/IZones";

export default (form: Partial<IZones>) => {
    const parsedForm: Partial<IZones> = {
        ...form,
    };

    return parsedForm;
};
